import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AutoLogoutState {
  enabled: boolean;
}

const initialState: AutoLogoutState = {
  enabled: true, // Auto logout is enabled by default
};

const autoLogoutSlice = createSlice({
  name: "autoLogout",
  initialState,
  reducers: {
    setAutoLogoutEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
    },
    toggleAutoLogout(state) {
      state.enabled = !state.enabled;
    },
    resetAutoLogout() {
      return initialState;
    },
  },
});

export const { setAutoLogoutEnabled, toggleAutoLogout, resetAutoLogout } =
  autoLogoutSlice.actions;

export default autoLogoutSlice.reducer;
